import { useLocation, useNavigate } from 'react-router-dom';
import './login.css';
import { useContext, useEffect, useState } from 'react';
import { cartContext } from '../../App';

export default function OTPVerification() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const [timer, setTimer] = useState(60);
    const [otpUser, setOtpUser] = useState('');
    const [inCorrectOtp, setInCorrectOtp] = useState(false);
    const [sendAgainOtp, setSendAgainOtp] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setToUserId } = useContext(cartContext);

    const location = useLocation();
    const navigate = useNavigate();

    const emailId = location.state?.emailId || '';

    function handleVerification() {
        if (!otpUser) {
            setInCorrectOtp(true);
            return;
        }

        setLoading(true);

        const dataToSend = {
            userId: emailId,
            otp: otpUser
        };

        fetch(`${BACKEND_URL}/otp-verification`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${AUTH_TOKEN}`,
                'content-type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success === true) {
                    localStorage.setItem(
                        'userId',
                        JSON.stringify(emailId)
                    );
                    setToUserId(emailId);
                    navigate('/');
                } else {
                    setInCorrectOtp(true);
                }
            })
            .catch((err) => {
                alert('Something went wrong');
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function handleSendOtpAgain() {
        setTimer(60);
        setSendAgainOtp(false);
        setLoading(true);

        const dataToSend = {
            userId: emailId
        };

        fetch(`${BACKEND_URL}/login`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${AUTH_TOKEN}`,
                'content-type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
            .then((response) => response.json())
            .then(() => {
                navigate('/otp-verification', {
                    state: { emailId }
                });
            })
            .catch((error) => {
                console.log(error);
                alert('Error occurred!');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    setSendAgainOtp(true);
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [sendAgainOtp]);

    const formattedTimer = timer.toString().padStart(2, '0');

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="login-logo-container">
                    <img
                        src="brand-icons/freslo-full-icon.png"
                        alt="logo"
                        className="login-logo"
                    />
                </div>

                <p className="login-heading">Verify OTP</p>

                <p className="login-subtitle">
                    OTP sent to <span className="otp-email">{emailId}</span>
                </p>

                <p className="otp-timer">
                    00:{formattedTimer} sec
                </p>

                {sendAgainOtp && (
                    <p className="otp-resend-text">
                        Didn’t get it?{" "}
                        <span
                            className="otp-resend-link"
                            onClick={handleSendOtpAgain}
                        >
                            Send OTP
                        </span>
                    </p>
                )}

                <div className="login-input-wrapper">
                    <span className="login-input-icon">🔐</span>
                    <input
                        type="number"
                        placeholder="Enter OTP"
                        className="phone-input-login"
                        value={otpUser}
                        onChange={(e) =>
                            setOtpUser(e.target.value)
                        }
                    />
                </div>

                {inCorrectOtp && (
                    <p className="login-error">
                        Invalid OTP. Please try again.
                    </p>
                )}

                <div
                    className="login-otp-btn"
                    onClick={handleVerification}
                >
                    {loading ? (
                        <div className="spinner"></div>
                    ) : (
                        "Verify OTP"
                    )}
                </div>
            </div>
        </div>
    );
}